angular.module('aprima-legacy-common', [
    'ui.router',
    'restangular',
    'ngTouch',
    'ngAnimate',
    'ui.bootstrap',
    'angularLocalStorage',
    'gettext',
    'lodash',
    'toaster',
    'rt.debounce',
    'hmTouchEvents',

    //aprima
    'aprima-core',
    'aprima-bridge',
    'aprima-config'
]);